module.exports = __webpack_public_path__ + "static/media/fr.61ececcb.png";